// src/App.js
import React, { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import CustomSection from "./components/CustomSection";
import About from "./components/About";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AgeRestriction from "./components/AgeRestriction";
import CookieBanner from "./components/CookieBanner";
import PrivacyPolicy from "./components/PrivacyPolicy";

function App() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  const handlePrivacyClick = () => {
    setShowPrivacyPolicy(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBackFromPrivacy = () => {
    setShowPrivacyPolicy(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (showPrivacyPolicy) {
    return (
      <>
        <AgeRestriction />
        <CookieBanner onPrivacyClick={handlePrivacyClick} />
        <PrivacyPolicy onBack={handleBackFromPrivacy} />
      </>
    );
  }

  return (
    <>
      <AgeRestriction />
      <CookieBanner onPrivacyClick={handlePrivacyClick} />
      <Navbar />
      <main>
        <section id="pocetna">
          <Hero />
        </section>

        <section id="ponuda">
          <Categories />
        </section>

        <section id="custom">
          <CustomSection />
        </section>

        <section id="galerija">
          <Gallery />
        </section>

        <section id="onama">
          <About />
        </section>

        <section id="kontakt">
          <Contact />
        </section>
      </main>
      <Footer onPrivacyClick={handlePrivacyClick} />
    </>
  );
}

export default App;
